// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Indonesia from '../_raw/flag/icon_flag_indonesia.png';

export default () => <img src={Indonesia} alt="Indonesia" />;
